// libraries.
import { Outlet } from "react-router-dom";

// components.
import { SidebarRules } from "./components/SidebarRules/SidebarRules";

export const RulesPage = () => {
  return (
    <div className="d-flex overflow-hidden h-100">
      <div>
        <SidebarRules />
      </div>
      <div
        className="d-flex flex-column w-100 h-100"
        data-testid="rules-page"
      >
        <Outlet />
      </div>
    </div>
  );
};

